import Link from 'next/link';
import styles from '@components/SingleArticle/SingleArticle.styles';
import { ICmsDocument } from '@features/cms/typescript';
import { stripBrTags } from '@utils/splitTextByLineBreaks';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  article: ICmsDocument;
};
const SingleArticle = ({
  article
}: PropsType) => <Link href={`/inspirations/ideas/${article.baseData?.slug}`}>
    <div sx={styles.articleImage}>
      <ResponsiveImage image={article.baseData?.image || ''} alt={article.baseData?.name || ''} />
    </div>
    <p className="subtitle" sx={styles.articleTitle}>
      {stripBrTags(article.baseData?.name)}
    </p>
  </Link>;
export default SingleArticle;